var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.breaches,"items-per-page":5,"hide-default-footer":""}})}
var staticRenderFns = []

export { render, staticRenderFns }